export default __webpack_public_path__ + "static/media/Montserrat-Italic.58b98b5c.ttf";